export default __webpack_public_path__ + "static/media/stats.82d379f9.svg";